import { t } from 'i18next'
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import AccessContext from '../../context/AccessContext/AccessContext';
import ButtonBlackReturn from '../Buttons/ButtonBlackReturn';
import { ButtonBlue } from '../Buttons/ButtonBlue';
import ItemSelectableWithCheck from '../ItemSelectable/ItemSelectableWithCheck';
import { getTenantInfoByKey, getUserBuilding } from '../../helpers/helpers';
import AccessAreaContext from '../../context/AccessAreaContext/AccessAreaContext';
import { Spinner } from 'reactstrap';
import ErrorScreen from '../MessagesScreens/ErrorScreen';

const AccessWith = () => {

  const { accessState, setStep, clean, setAccessWith } = useContext(AccessContext);
  const { employee, contractors, type } = accessState

  const { accessAreaState, getAccessAreas } = useContext(AccessAreaContext);

  const { accessAreas, isFetching, error, message } = accessAreaState;

  const areaExist = accessAreas.length > 0;

  const navigate = useNavigate();

  const isAccess = ['ACCESS', 'ACCESS_VISIT'].some(typeOption => typeOption === type);

  const isVisit = type === 'ACCESS_VISIT';

  const userBuilding = getUserBuilding().buildingId;
  const haveAccessBuildings = getTenantInfoByKey('is_building');
  const buildingIdExist = userBuilding !== "" && haveAccessBuildings === true;


  const equipmentOrToolsOption = getTenantInfoByKey('has_enabled_equipments_type') ?
    [{
      type: t('EQUIPMENT_OR_TOOLS'),
      description: t('THE_PERSON_ACCESS_WITH_EQUIPMENT_OR_TOOLS'),
      image: 'equipment-tools-access-icon.svg',
      checked: false,
      disabled: false,
      key: 'accessWithEquipmentOrTools'

    }]
    :
    []

  const accessOptions = [
    {
      type: t('VEH'),
      description: isAccess ? t('ACCESS_WITH_CAR') : t('EXIT_WITH_CAR'),
      image: 'vehicle-select-icon.svg',
      checked: false,
      disabled: employee && !employee.is_driver,
      key: 'accessWithCar'
    },
    ...equipmentOrToolsOption
  ];

  const [options, setOptions] = useState(accessOptions);

  const handleChangeCheck = (value, type) => {
    const newData = options.map((option) => (
      option.type === type ? { ...option, checked: value } : option
    ))
    setOptions(newData)
  }

  const handleNextStep = () => {
    const haveAccessBuildings = getUserBuilding().buildingDescription !== t('NO_BUILDING');

    const havePersonsToVisit = getTenantInfoByKey('has_people_to_visit');

    const accessWith = Object.assign(...options.map((option) => ({ [option.key]: option.checked })), {});

    const accessWithCar = accessWith.accessWithCar === true;

    const accessWithEquipmentOrTools = accessWith.accessWithEquipmentOrTools === true;

    setAccessWith(accessWith);

    if (accessWithCar) {
      const nextStep = isVisit ? 'VISIT_VEHICLE_FORM' : 'VEHICLES_SELECTABLE'
      setStep(nextStep);
      return
    };

    if (accessWithEquipmentOrTools) {
      setStep('SELECT_EQUIPMENT_OR_TOOLS');
      return
    };

    if (haveAccessBuildings && isAccess && areaExist) {
      setStep('SELECT_AREA');
      return
    };

    if (havePersonsToVisit && isAccess) {
      setStep('SELECT_PERSON_TO_VISIT');
      return
    }

    setStep('DETAIL')
    return
  }

  const handleGetBack = () => {
    const haveOtherOptions = contractors?.length > 1;

    if (isVisit) {
      setStep('VISIT_FORM');
      return
    }

    if (haveOtherOptions) {
      setStep('CONTRACTOR_SELECTABLE');
      return
    }

    navigate('/dashboard');
    clean();
  }

  useEffect(() => {
    if (buildingIdExist) {
      getAccessAreas([userBuilding])
    }
    // eslint-disable-next-line
  }, [])

  return (
    <>
      {isFetching && buildingIdExist && (
        <div className='d-flex justify-content-center mt-5'>
          <Spinner />
        </div>
      )}


      <div className='d-flex flex-column justify-content-between h-100'>
        <div>
          <h5 className='d-sm-block d-none fw-bold'>{isAccess ? t('PERSON_ENTRY_WITH') : t('PERSON_EXIT_WITH')}</h5>
          <div className="d-flex flex-column gap-3" style={{ maxHeight: '400px', overflowX: 'auto' }}>
            {
              options.map((option, idx) =>
                <ItemSelectableWithCheck
                  key={idx}
                  name={option.type}
                  checked={option.checked}
                  onChange={(e) => handleChangeCheck(e.target.checked, option.type)}
                  disabled={option.disabled}
                >
                  <div className='d-flex gap-3 align-items-center'>
                    <img
                      src={require(`../../assets/${option.image}`)}
                      alt=""
                    />
                    <div>
                      <h6 className='m-0 custom-h4 fw-500'>{option.type}</h6>
                      <span className='subtitle'>{option.description}</span>
                    </div>
                  </div>
                </ItemSelectableWithCheck>
              )
            }
          </div>
        </div>
        <div className='d-flex justify-content-between align-items-center mt-4 mb-4'>
          <div className="w-75">
            <ButtonBlackReturn title={t('GET_BACK')} onClick={handleGetBack} />
          </div>
          <div className="w-50">
            <ButtonBlue className='w-100' onClick={handleNextStep}>
              {t('NEXT')}
            </ButtonBlue>
          </div>
        </div>
      </div>

      {error && buildingIdExist && (<ErrorScreen title={'Error'} description={message} />)}

    </>

  )
}

export default AccessWith